import React, {useEffect, SetStateAction} from 'react'

export const useOutsideClick = (ref: any, setShow: React.Dispatch<SetStateAction<boolean>>) => {
  useEffect(() => {
    function handleClickOutside(event: any) {
      if (ref.current && !ref.current.contains(event.target)) {
        setShow(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
}